<template>
  <div class="cadfm-container-horizontal">
            <Left v-show="isVisibleLeft" :lang="lang.Left"></Left>
            <Middle  :lang="lang.Middle"></Middle>
            <!--<Right></Right>-->
 </div>
</template>

<script>
import Left from "@/components/ProjectManager/Views/ProjectDerive/Left/Left";
import Middle from "@/components/ProjectManager/Views/ProjectDerive/Middle/Middle";
//import Right from '@/components/ProjectManager/Views/ProjectDerive/Right/Right'
import { mapGetters } from "vuex";

export default {
  name: "ProjectDerive",
  components: {
    Left,
    Middle
    //Right
  },
  props: {
    routingData: Object,
    lang: Object
  },
  data() {
    return {
      isVisibleRight: true,
      isVisibleLeft: true
    };
  },
  computed: {
    ...mapGetters(["isPlugin"])
  }
};
</script>


<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ProjectManager/Views/ProjectDerive.vue